
export default {
  methods: {
    userAdm() {
      for (var grupo of this.$store.state.auth.user.grupos) {
        if (grupo.nomeGrupo.toUpperCase() === 'ADMINISTRADOR') {
          return true
        }
      }
      return false
    },

    userLegislacoes() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'LEGISLACOES') {
            return true
          } 
        }
        return false
      }
    },

    userDocumentos() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'DOCUMENTOS') {
            return true
          } 
        }
        return false
      }
    },

    userLicitacoes() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'LICITACOES') {
            return true
          }
        }
        return false
      }
    },

    userPrejulgados() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'PREJULGADOS') {
            return true
          } 
        }
        return false
      }
    },

    userSumulas() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'SUMULAS') {
            return true
          } 
        }
        return false
      }
    },

    userSancoes() {
      if (this.$store.state.auth.user) {
        for (var grupo of this.$store.state.auth.user.grupos) {
          if (grupo.nomeGrupo.toUpperCase() === 'SANCOES') {
            return true
          }
        }
        return false
      }
    },

    userHasPermission(){

      if(this.userAdm()){
        return true
      }

      if(this.$router.history.current.meta.grupo){

        for (var grupo of this.$store.state.auth.user.grupos) {
          if ( grupo.nomeGrupo.toUpperCase() === this.$router.history.current.meta.grupo)
          {
            return true
          }
        }
          return false
      }
      return true
    }

  }
}